import { useEffect, useRef, useState } from 'react';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import './manage-lottery-landing.styles.scss';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import LotteryList from './lottery-list.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTicket } from '@fortawesome/free-solid-svg-icons';
import LotteryView from './lottery-view.component';
import { getCollectionFromDb, getLotteryDataFromDb } from '@/utils/getDataFromDb';
import { completeGameElementData } from '@/components/PREVIEW/previewGameElements';
import { off } from 'firebase/database';

const ManageLotteryLanding = ({
  gameData,
  playerList,
  gameStats,
  gameElements
}) => {

  const [lotteriesToDisplay, setLotteriesToDisplay] = useState([]);
  const [ticketLists, setTicketLists] = useState({});
  const lotteryRef = useRef({});
  const ticketListsListenerRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();

  const gameId = gameData?.gameId;
  const isPreview = location.pathname.includes('/preview/manager/');

  useEffect(() => {
    if (!gameData?.gameName) return;
    changeDocumentTitle(`Lotteries | Manage ${gameData?.gameName}`);
  }, [gameData?.gameName])

  useEffect(() => {
    if (!gameId) return;
    getLotteriesToDisplay();
    getTicketLists();

    function getLotteriesToDisplay() {
      if (isPreview) {
        const lotteries = Object.values(completeGameElementData)
          .filter(el => el.opt_itemType === 'lottery' && el.status === 'active');
        lotteryRef.current = {
          ...lotteryRef.current,
          ...lotteries.reduce((acc, el) => ({ ...acc, [el.id]: el }), {})
        }
        setLotteriesToDisplay(Object.values(lotteryRef.current));
        return;
      }
      getCollectionFromDb({
        "collection": `games/${gameId}/gameElements`,
        "query1": {
          "key": "opt_itemType",
          "condition": "==",
          "value": "lottery"
        },
        "query2": {
          "key": "status",
          "condition": "==",
          "value": "active"
        },
        "once": true,
        "callback": callback
      })
      function callback(data) {
        console.log(data);
        lotteryRef.current = {
          ...lotteryRef.current,
          ...{ [data.id]: data }
        }
        setLotteriesToDisplay(Object.values(lotteryRef.current));
      }
    }

    function getTicketLists() {
      getLotteryDataFromDb({
        "gameId": gameId,
        "callback": callback,
        "handleListener": handleListener
      })
      function callback(data) {
        setTicketLists(data);
      }
      function handleListener(unsub) {
        ticketListsListenerRef.current = unsub;
      }
    }

    return () => {
      if (ticketListsListenerRef.current) {
        off(ticketListsListenerRef.current);
      }
    }
  }, [gameId, isPreview, completeGameElementData]);



  return (
    <div className='manage-lottery-landing'>
      <div className='g-card manage-lottery-card'>
        <BackButton cancel={() => navigate(-1)} />
        <div className="g-space-1"></div>
        <div className='card-title'>
          <div className='title-with-icon'>
            <FontAwesomeIcon icon={faTicket} />Lottery Manager
          </div>
        </div>
        <hr />
        <Routes>
          <Route path='' element={
            <LotteryList
              gameData={gameData}
              gameElements={gameElements}
              gameStats={gameStats}
              playerList={playerList}
              lotteriesToDisplay={lotteriesToDisplay}
              ticketLists={ticketLists}
            />
          }></Route>
          <Route path=':lotteryPath' element={
            <LotteryView
              gameData={gameData}
              gameElements={gameElements}
              gameStats={gameStats}
              playerList={playerList}
              lotteriesToDisplay={lotteriesToDisplay}
              ticketLists={ticketLists} />
          }></Route>
        </Routes>
      </div>
    </div>
  )
}

export default ManageLotteryLanding